import MultipleSelection from './MultipleSelection';

export default MultipleSelection;
